var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.05 10.96H8.93C8.51579 10.96 8.18 10.6242 8.18 10.21C8.18 9.79579 8.51579 9.46 8.93 9.46H12.05C12.4642 9.46 12.8 9.79579 12.8 10.21C12.8 10.6242 12.4642 10.96 12.05 10.96Z",
    fill: "#0D0C0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93 12.57H15.07C15.4842 12.57 15.82 12.9058 15.82 13.32C15.82 13.7342 15.4842 14.07 15.07 14.07H8.93C8.51579 14.07 8.18 13.7342 8.18 13.32C8.18 12.9058 8.51579 12.57 8.93 12.57Z",
    fill: "#0D0C0C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.23 15.5H8.93C8.51579 15.5 8.18 15.8358 8.18 16.25C8.18 16.6642 8.51579 17 8.93 17H14.23C14.6442 17 14.98 16.6642 14.98 16.25C14.98 15.8358 14.6442 15.5 14.23 15.5Z",
    fill: "#0D0C0C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.27 2C15.0792 1.99888 15.7474 2.63193 15.79 3.44C18.1649 3.70703 19.9696 5.70032 20 8.09V18.18C19.9945 20.8011 17.8711 22.9245 15.25 22.93H8.75C6.12893 22.9245 4.0055 20.8011 4 18.18V8.09C4.03041 5.70032 5.83508 3.70703 8.21 3.44C8.25747 2.63419 8.9228 2.00388 9.73 2H14.27ZM14.29 3.44H9.73V4.63H14.29V3.44ZM18.5 18.18C18.5 19.9766 17.0465 21.4345 15.25 21.44H8.75C6.95345 21.4345 5.49999 19.9766 5.5 18.18V8.09C5.50398 6.49887 6.65936 5.14458 8.23 4.89C8.35276 5.62136 8.98843 6.15532 9.73 6.15H14.27C15.0116 6.15532 15.6472 5.62136 15.77 4.89C17.3406 5.14458 18.496 6.49887 18.5 8.09V18.18Z",
    fill: "#0D0C0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.a19cdde919a8e0fbf77a3f9e22f79638.svg";
export { ForwardRef as ReactComponent };